import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randFood } from "@ngneat/falso";

type Options = Exclude<Parameters<typeof randFood>[0], undefined>;
type Origin = Exclude<Options["origin"], undefined> | "";

const origins: Record<Origin, string> = {
  "": "",
  china: "china",
  italy: "italy",
  india: "india",
  mexico: "mexico",
  japan: "japan",
  france: "france",
  lebanon: "lebanon",
  thailand: "thailand",
  romania: "romania",
  greece: "greece",
  turkey: "turkey",
  spain: "spain",
  venezuela: "venezuela",
  argentina: "argentina",
  colombia: "colombia",
  chile: "chile",
  peru: "peru",
  "el salvador": "el salvador",
  ecuador: "ecuador",
};

export const randFoodNodeDef = createNodeDef({
  type: "randFood",
  displayName: "Food",
  defaultName: "food",
  fields: [
    {
      type: DataFieldType.SELECT,
      key: "origin",
      label: "Origin",
      options: origins,
    },
  ],
  initialData: () => ({ origin: "" as Origin }),
  generate: ({ node }) => {
    return randFood({ origin: node.data.origin || undefined });
  },
});
